import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private sessionService: SessionService,
    private msalService: MsalService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(environment.api)) {
      return next.handle(req);
    }

    if (req.headers.has('Authorization')) {
      return next.handle(req);
    }

    const sessionToken = this.sessionService.getAccessToken();
    if (sessionToken && !this.sessionService.isTokenExpired()) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${sessionToken}`
        }
      });
      return next.handle(authReq);
    }

    return next.handle(req);
  }
}
